import { useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { components as select } from 'react-select';

import StarIcon from '@chronos/components/Icons/StarIcon';
import * as S from './styled';

const getBoardsOptions = (arr) =>
  arr.map((item) => ({
    label: item.name,
    value: item.id.toString(),
    starred: item.starred,
  }));

const Option = ({ children, ...props }) => (
  <select.Option {...props}>
    <S.OptionContainer>
      <span>{children}</span>
      {props.data?.starred && <StarIcon />}
    </S.OptionContainer>
  </select.Option>
);

const SingleValue = ({ children, ...props }) => (
  <select.SingleValue {...props}>
    <S.OptionContainer>
      <span>{children}</span>
      {props.selectProps?.value?.starred && <StarIcon />}
    </S.OptionContainer>
  </select.SingleValue>
);

const BoardsSelect = ({ boards, value, onChange }) => {
  const options = useMemo(() => getBoardsOptions(boards), [boards]);
  const selectedOption = options.find((option) => option.value === value);
  const handleChange = useCallback((option) => {
    onChange(option.value);
  }, []);

  return (
    <S.Select
      value={selectedOption}
      options={options}
      placeholder="Select a board"
      menuPlacement="top"
      onChange={handleChange}
      components={{
        Option,
        SingleValue,
      }}
    />
  );
};

BoardsSelect.defaultProps = {
  boards: [],
  value: null,
};

BoardsSelect.propTypes = {
  boards: PropTypes.array,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default BoardsSelect;
